import React from 'react';
import { Box, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';

import plastigama from '../../static/media/home/marcas/plastigama.webp';
import rival from '../../static/media/home/marcas/rival.webp';
import era from '../../static/media/home/marcas/era.webp';
import polimex from '../../static/media/home/marcas/polimex.webp';
import fv from '../../static/media/home/marcas/fv.webp';
import ptk from '../../static/media/home/marcas/ptk.webp';
import toyo from '../../static/media/home/marcas/toyo.webp';
import weldon from '../../static/media/home/marcas/weldon.webp';
import doublelin from '../../static/media/home/marcas/doublelin.webp';

const logos = [
  plastigama,
  rival,
  era,
  polimex,
  fv,
  ptk,
  toyo,
  weldon,
  doublelin
];

const SwiperBrands = () => {
  return (
    <Box sx={{ py: 6, textAlign: 'center', px: 2 }}>
      <Typography
        component="h2"
        sx={{
          fontWeight: 'bold',
          mb: 4,
          color: '#555',
          fontSize: {
            xs: '1rem',
            sm: '1rem',
            md: '1.25rem',
            lg: '1.3rem',
          },
        }}
      >
        TRABAJAMOS CON LAS MEJORES MARCAS DEL MERCADO
      </Typography>

      <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={50}
          autoplay={{ delay: 2000, pauseOnMouseEnter: true }}
          loop={true}
          grabCursor={true}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 30 },
            600: { slidesPerView: 3, spaceBetween: 40 },
            900: { slidesPerView: 4, spaceBetween: 50 },
            1200: { slidesPerView: 5, spaceBetween: 60 },
          }}
        >
          {logos.map((logo, index) => (
            <SwiperSlide key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true, amount: 0.1 }}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt={`Logo ${index + 1}`}
                  width={120}
                  height={60}
                  sx={{
                    width: { xs: '90px', sm: '110px', md: '130px' },
                    height: { xs: '50px', sm: '60px', md: '70px' },
                    objectFit: 'contain',
                  }}
                />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
};

export default SwiperBrands;
